/**
 * Design system tokens for consistent styling across the app.
 */
export const tokens = {
  fontFamily: {
    primary: '"Rethink Sans", Helvetica, sans-serif',
  },
  color: {
    primary: "#536DEC",
    primaryHover: "#4C63D7",
    primaryActive: "#465EDB",
  },
  borderRadius: {
    button: "8px",
    buttonSmall: "6px",
  },
};